"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
const Button_1 = __importDefault(require("./Button"));
const Snackbar_1 = __importDefault(require("./Snackbar"));
const CopyButton = props => {
    const { value, successMessage, onClick } = props, rest = __rest(props, ["value", "successMessage", "onClick"]);
    const [copied, setCopied] = react_1.useState(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Snackbar_1.default, { show: copied, delay: 2000, onHideSnackbar: () => setCopied(false) }, successMessage),
        react_1.default.createElement(Button_1.default, Object.assign({}, rest, { onClick: e => {
                copy_to_clipboard_1.default(value);
                setCopied(true);
                if (onClick) {
                    onClick(e);
                }
            } }), props.children || 'Copy')));
};
CopyButton.propTypes = Object.assign({ value: prop_types_1.default.string, successMessage: prop_types_1.default.string }, Button_1.default.propTypes);
CopyButton.defaultProps = {
    successMessage: 'Copied successfully.',
};
exports.default = CopyButton;
